module.exports = __webpack_public_path__ + "img/step2-se.e6368d88.png";